"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LINK_DESTINATION_NONE = exports.LINK_DESTINATION_MEDIA_WP_CORE = exports.LINK_DESTINATION_MEDIA = exports.LINK_DESTINATION_ATTACHMENT_WP_CORE = exports.LINK_DESTINATION_ATTACHMENT = void 0;
const LINK_DESTINATION_NONE = 'none';
exports.LINK_DESTINATION_NONE = LINK_DESTINATION_NONE;
const LINK_DESTINATION_MEDIA = 'media';
exports.LINK_DESTINATION_MEDIA = LINK_DESTINATION_MEDIA;
const LINK_DESTINATION_ATTACHMENT = 'attachment';
exports.LINK_DESTINATION_ATTACHMENT = LINK_DESTINATION_ATTACHMENT;
const LINK_DESTINATION_MEDIA_WP_CORE = 'file';
exports.LINK_DESTINATION_MEDIA_WP_CORE = LINK_DESTINATION_MEDIA_WP_CORE;
const LINK_DESTINATION_ATTACHMENT_WP_CORE = 'post';
exports.LINK_DESTINATION_ATTACHMENT_WP_CORE = LINK_DESTINATION_ATTACHMENT_WP_CORE;
//# sourceMappingURL=constants.js.map